// material-ui
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Box, IconButton, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import LogoSmall from '../../../../src/assets/images/media/logo_small.png';
import { Profile } from './Profile';
import { AppBarStyled } from './styles';

interface Props {
  open: boolean;
  handleDrawerToggle: () => void;
}

export const Header = ({ open, handleDrawerToggle }: Props) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

  const mainHeader = (
    <Toolbar sx={{ backgroundColor: theme.palette.primary.main }}>
      <Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>
        {matchDownSM && (
          <Box justifyContent="center" alignItems="center" display="flex">
            <img src={LogoSmall} alt="Logo" style={{ maxWidth: '50px', height: 'auto', objectFit: 'cover', alignSelf: 'center' }} />
          </Box>
        )}
        <IconButton
          disableRipple
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          sx={{
            color: theme.palette.common.white
          }}
        >
          {!matchDownSM && <>{!open ? <MenuIcon fontSize="medium" /> : <MenuOpenIcon fontSize="medium" />}</>}
        </IconButton>
        <Profile />
      </Box>
    </Toolbar>
  );

  //ESTILOS DA BARRA DO HEADER
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    sx: {
      backgroundColor: theme.palette.common.white
    }
  };

  return (
    <AppBarStyled open={open} isMobile={matchDownMD ? true : undefined} {...appBar}>
      {mainHeader}
    </AppBarStyled>
  );
};
